import { GlFilteredSearchToken, GlFilteredSearchSuggestion } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'JobKindToken',
    components: {
        GlFilteredSearchToken,
        GlFilteredSearchSuggestion
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        config: {
            type: Object,
            required: true
        },
        value: {
            type: Object,
            required: true
        }
    },
    computed: {
        jobKinds () {
            return [
                {
                    text: s__('Job|Build'),
                    value: 'BUILD'
                },
                {
                    text: s__('Job|Trigger'),
                    value: 'BRIDGE'
                }
            ];
        },
        activeJobKind () {
            return this.jobKinds.find((kind)=>kind.value === this.value.data) || {};
        }
    }
};
